import BreadcrumbTitle from './BreadcrumbTitle';

export default BreadcrumbTitle;
